module.exports = __webpack_public_path__ + "static/media/icon-pending-blue.501afeb9.svg";